import { BoxProps, Flex } from '@chakra-ui/react';
import { useCurrentColors } from '../../hooks/UseCurrentColors/UseCurrentColors';
interface SuccessBoxProps extends BoxProps {
    successMessage: string;
}
function SuccessBox({ successMessage, ...props }: SuccessBoxProps) {
    const currentColors = useCurrentColors();
    return (
        <Flex
            position="fixed"
            justify="center"
            align="center"
            direction="column"
            width="100%"
            height="100%"
            p="16px"
            fontSize="14px"
            color={currentColors.contentText}
            {...props}>
            {successMessage}
        </Flex>
    );
}

export default SuccessBox;
